import { Grid, Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
// import { toastFail, toastSuccess } from "@tms/components/Toast";
// import { useFeedbackQuestion } from "@tms/services/tms-feedback";
import { useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import RadioGroup from './RadioGroupComponent';
// import TextInput from "@tms/components/Form/I/nput";
// import { useMutationSaveTrainingFeedbackAnswer } from "@tms/services/tms-feedback";
import React from 'react';
import {
  useFeedbackQuestion,
  useMutationSaveTrainingFeedbackAnswer
} from 'redux/reducers/user/dashboard/tms-feedback';
import { toast } from 'react-toastify';
import UserTextInput from 'components/UserInput/UInput';

interface ItrainingFeedbackModal {
  openFeedbackModal: any;
  handleCloseFeedbackModal: () => void;
  routineId: string;
  item: any;
}

interface IFeedbackAns {
  daily_session: string;
  routine_feedback_que_id: string;
  feedback_question_id: string;
  feedback_point?: string;
  feedback_answer?: string;
}

const TrainingFeedbackModal = ({
  openFeedbackModal,
  handleCloseFeedbackModal,
  routineId,
  item
}: ItrainingFeedbackModal) => {
  const { control, reset, watch, setValue, handleSubmit } = useForm({
    defaultValues: {
      feedbackAnswers: [] as IFeedbackAns[]
    }
  });

  const feedbackAns = watch('feedbackAnswers');

  const { mutateAsync, isLoading } = useMutationSaveTrainingFeedbackAnswer();

  const onSubmitHandler = async () => {
    try {
      await mutateAsync(feedbackAns);
      handleCloseFeedbackModal();
      toast.success('Training Feedback Created Successfully');
    } catch (error: any) {
      reset();
      toast.error(error.response.data[0].non_field_errors);
    }
  };
  const { data: trainingFeedbackQuestion, isLoading: isLoadingFeedBack } = useFeedbackQuestion(
    routineId?.toString() ?? '',
    'training'
  );
  const trainingFeedbackQuestionList = React.useMemo(
    () => trainingFeedbackQuestion?.flatMap((fq) => fq.feedback_question_details) ?? [],
    [trainingFeedbackQuestion]
  );

  React.useEffect(() => {
    if (trainingFeedbackQuestionList.length) {
      const mulitpleAnswers = trainingFeedbackQuestionList
        .filter((data, index) => {
          return data.question_type == 'm';
        })
        .map((data, index) => {
          return {
            training: trainingFeedbackQuestion?.[0].training_routine_details.training_details.id,
            routine_feedback_que_id:
              trainingFeedbackQuestion?.[0]?.routine_feedback_que_id?.toString() ?? '',
            feedback_question_id: data.tms_feedback_question_id,
            feedback_point: ''
          };
        });
      const shortAnswers = trainingFeedbackQuestionList
        .filter((data, index) => {
          return data.question_type == 's';
        })
        .map((data, index) => {
          return {
            training: trainingFeedbackQuestion?.[0].training_routine_details.training_details.id,
            routine_feedback_que_id:
              trainingFeedbackQuestion?.[0]?.routine_feedback_que_id?.toString() ?? '',
            feedback_question_id: data.tms_feedback_question_id,
            feedback_answer: ''
          };
        });

      reset({ feedbackAnswers: [...mulitpleAnswers, ...shortAnswers] });
    }
  }, [trainingFeedbackQuestionList, trainingFeedbackQuestion, routineId]);

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth="lg"
        open={openFeedbackModal}
        onClose={handleCloseFeedbackModal}>
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h4" gutterBottom>
            {item?.training_data[0].training_name}
          </Typography>{' '}
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit(onSubmitHandler)}>
            <Grid container columnSpacing={4}>
              <Grid item xs={5}></Grid>
              <Grid item xs={7} sx={{ float: 'right' }}>
                <Stack direction={'row'} display={'flex'} justifyContent={'center'}>
                  <i>In the given likert scale number 1 indicates poor and 4 indicates best.</i>
                </Stack>
                <Stack direction={'row'} justifyContent={'space-around'}>
                  {[...Array(4)].map((item, index) => (
                    <>
                      <Typography>{index + 1}</Typography>
                    </>
                  ))}
                </Stack>
              </Grid>
            </Grid>
            {trainingFeedbackQuestionList
              .filter((q) => q.question_type === 'm')
              .map((item, index) => {
                return (
                  <RadioGroup
                    key={item.tms_feedback_question_id}
                    item={item}
                    selectedValue={
                      feedbackAns.find(
                        (a) => a.feedback_question_id === item.tms_feedback_question_id
                      )?.feedback_point ?? ''
                    }
                    onChange={(value) => {
                      setValue(
                        'feedbackAnswers',
                        feedbackAns.map((a, inde) => ({
                          ...a,
                          feedback_point:
                            a.feedback_question_id === item.tms_feedback_question_id
                              ? value
                              : a.feedback_point
                        }))
                      );
                    }}
                  />
                );
              })}
            <hr />
            {trainingFeedbackQuestionList
              .filter((q) => q.question_type === 's')
              .map((item) => {
                return (
                  <>
                    <Grid container justifyContent={'space-between'}>
                      <Grid xs={6}>
                        <Typography>{item?.question}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <UserTextInput
                          label={'Answer the question'}
                          type="text"
                          name="dis"
                          control={control}
                          sx={{ height: '50px' }}
                          value={
                            feedbackAns.find(
                              (a) => a.feedback_question_id === item.tms_feedback_question_id
                            )?.feedback_answer ?? ''
                          }
                          onChange={({ target: { value } }) => {
                            setValue(
                              'feedbackAnswers',
                              feedbackAns.map((a: any) => ({
                                ...a,
                                feedback_answer:
                                  a.feedback_question_id === item.tms_feedback_question_id
                                    ? value
                                    : a.feedback_answer
                              }))
                            );
                          }}
                        />
                      </Grid>
                    </Grid>
                  </>
                );
              })}

            <hr />
            <>
              <Button
                variant="outlined"
                onClick={handleCloseFeedbackModal}
                sx={{ marginRight: '8px' }}>
                Cancel
              </Button>
              <Button variant="contained" autoFocus type="submit" disabled={isLoading}>
                {isLoading ? "Submitting.." : "Submit"}
              </Button>
            </>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default TrainingFeedbackModal;
